import PageLayout from 'pages/CreateRubricAI/PageLayout';
import PageProvider from 'pages/CreateRubricAI/PageProvider';

const CreateRubricAIPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default CreateRubricAIPage;
